import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';

import { getArtisanProductAction } from '../../../../modules/artisanProducts/Actions';

import {
  getPendingArtisanProductsAction,
  deleteSinglePendingArtisanProdcutAction,
  getSinglePendingArtisanProductAction,
  moderateCreateSinglePendingArtisanProductAction,
  updatePendingArtisanProductAction,
} from '../../../../modules/artisanModeration/artisanProducts/Actions';
import {
  artisanProductsIsLoadingSelector,
  artisanProductByIdSelector,
} from '../../../../modules/artisanProducts/Selectors';

import {
  InputField,
  CheckBox,
  TextArea,
  MultiInputField,
  SearchableSelect,
  MultiUpload,
  FormSectionTitle,
  Separator,
} from '../../../../components/form/';

import ModerationForm from '../../../../components/form/ModerationForm';
import { pendingArtisanProductByIdSelector } from '../../../../modules/artisanModeration/artisanProducts/Selectors';
import axiosInstance from '../../../../helpers/api';
import { errorNotificationFromError } from '../../../../modules/notifications/Actions';
import getLangData from '../../../../utils/getLangData';

const ArtisanProductsForm = (props) => {
  const {
    productId,
    moderationId,
    isLoading,
    updateArtisanProduct,
    getArtisanProduct,
    artisanProduct,
    deleteArtisan,
    moderateArtisanProduct,
    getProducts,
    errorNotificationFromError
  } = props;
  const lang = getLangData().fields
  useEffect(() => {
    // getArtisanProduct(productId);
    getProducts();
  }, [getArtisanProduct, productId]);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...artisanProduct,
      }}
      onSubmit={(values) => {
        moderateArtisanProduct({
          id: productId,
        }, values.moderationType);
      }}
    >
      {({ values, handleSubmit }) => (
        <>
          <ModerationForm
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            isDisabled={false}
            heading={
              artisanProduct
                ? `${lang.update} [${artisanProduct.name}]`
                : lang.create_artisan_product
            }
          >
            {console.log(artisanProduct, 'artisanProduct')}
            <FormSectionTitle>{lang.basic_information}</FormSectionTitle>

            <InputField
              name="artisanData[0].businessName"
              label={lang.artisan}
            // getLabel='businessName'
            />
            <InputField name='name' label={lang.product_name} />
            <InputField name='productID' label={lang.product_id} />
            <SearchableSelect name='categoryData' label={lang.categore} />
            <SearchableSelect isMulti={true} name='tagsData' label={lang.tags} />
            <TextArea name='description' label={lang.descrition} />
            <MultiInputField name='metaKeywords' label={lang.keywords} />
            <MultiInputField name='material' label={lang.material} />
            {/* <MultiInputField name='colors' label='Colors' /> */}
            <InputField name='size' label={lang.size} />
            <InputField name='usage' label={lang.usage} />
            <InputField
              name="priceTo"
              label={lang.price_to}
              placeholder={getLangData().general_words.start_price_ex}
            />

            <CheckBox name="discounted" label={lang.discounted} />
            {values.discounted && <InputField name="discount" label={lang.discount} />}
            {/*           {values.discounted && <DatePicker name='offerExpires' label='Offer Expires' />}
           */}
            <CheckBox name="hasBuyNowLink" label={lang.has_buy_now_link} />
            {values.hasBuyNowLink && (
              <InputField name="buyNowLink" label={getLangData().general_words.buy_now_link} />
            )}

            <MultiUpload
              data={{ customerID: 'dsads9123213k219d120' }}
              S3Bucket="warshatna-users"
              API="customer/customer-category-image-signedurl/"
              data=""
              name="productImages"
              label={`${getLangData().general_words.product_image} :`}
            />

            <Separator />
            <FormSectionTitle>{lang.product_status}</FormSectionTitle>
            <CheckBox name="packed" label={lang.packed} />
            <CheckBox name="shippableLocal" label={lang.shippable_local} />
            <CheckBox name="shippableInter" label={lang.shippable_inter} />
            {/* <CheckBox name='status' label='status' />
          <CheckBox name='moderated' label='moderated' /> */}

          </ModerationForm>
          <button className="btn btn-secondary mb-3" onClick={async () => {
            try {
              let data = values;
              delete data.geolocation;
              await axiosInstance.put(`/artisan-product/${data.productSourceID}`, data);
              await axiosInstance.delete(`/artisan-product-staging/${artisanProduct._id}`);
              window.location.href = '/artisans-moderation/artisans'
            } catch (error) {
              errorNotificationFromError(error)
            }
          }} >{lang.edit_approve}</button>
        </>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const productId = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    moderationId,
    productId,
    isLoading: artisanProductsIsLoadingSelector(state),
    // artisanProduct: artisanProductByIdSelector(state, productId),
    artisanProduct: pendingArtisanProductByIdSelector(state, productId),
  };
};

export default connect(mapStateToProps, {
  getArtisanProduct: getSinglePendingArtisanProductAction,
  moderateArtisanProduct: moderateCreateSinglePendingArtisanProductAction,
  deleteArtisanProduct: deleteSinglePendingArtisanProdcutAction,
  getProducts: getPendingArtisanProductsAction,
  errorNotificationFromError
})(ArtisanProductsForm);
